import React, { useState, useEffect } from 'react';
import {
  Alert,
  Icons,
  useTheme,
  AULA_LIGHT_ALERT_INFO_BG_COLOR,
  AULA_DARK_ALERT_INFO_BG_COLOR,
} from '@ublend-npm/aulaui-core';

const STORAGE_KEY = 'assignmentCreationAttempts';
const MAX_VIEWS = 3;
const UpcomingAssignmentAlert = () => {
  const [alertViews, setAlertViews] = useState(0);
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  useEffect(() => {
    const attempts = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '0') || 0;
    setAlertViews(attempts);
    if (attempts < MAX_VIEWS) {
      localStorage.setItem(STORAGE_KEY, String(attempts + 1));
    }
  }, []);

  if (alertViews >= MAX_VIEWS) return null;

  const textColor = isDark ? '#B8E7FB' : '#014361';
  const bgColor = isDark
    ? AULA_DARK_ALERT_INFO_BG_COLOR
    : AULA_LIGHT_ALERT_INFO_BG_COLOR;

  return (
    <Alert
      severity="info"
      icon={<Icons.InfoOutlined fontSize="small" />}
      sx={{
        bgcolor: bgColor,
        border: 'none',
        borderRadius: '8px',
        alignItems: 'flex-start',
        mb: { xs: '1rem', md: '1.5rem' },
        '& .MuiAlert-icon': {
          color: isDark ? '#29B6F6' : '#0288D1',
          marginTop: '1px',
        },
        '& .MuiAlert-message': {
          fontFamily: theme.typography.fontFamily,
          fontWeight: theme.typography.fontWeightRegular,
          fontSize: '0.875rem',
          lineHeight: '143%',
          letterSpacing: '0px',
          color: textColor,
          py: '8px',
        },
      }}
    >
      <span data-testid="upcoming-assignment-message">
        Before an assignment opens, students will be able to see the assignment
        title and dates only. Access to the assignment itself is disabled until
        the open date. You can still hide it completely as before.
      </span>
    </Alert>
  );
};

export default UpcomingAssignmentAlert;
